import React, { Component } from "react";
import { connect } from "react-redux";

import SectionContainer from "../../../components/Library/SectionContainer";
import { getEvents } from "../../actions/events";

import styles from "./UpcomingEvents.css";

class UpcomingEvents extends Component {
  componentDidMount() {
    this.props.getEvents();
  }

  render() {
    const { events } = this.props;
    if (!events.results.length) return null;

    return (
      <SectionContainer header="Upcoming Events" className={styles.root}>
        {events.results.map((event, index) => {
          return (
            <div key={`${event.title}-${index}`}>
              <div className={styles.event}>
                {event.artwork_url && (
                  <a target="_blank" href={event.rsvp_link}>
                    <img
                      className={styles.image}
                      src={event.artwork_url}
                      alt={event.title}
                    />
                  </a>
                )}
                <div>
                  <a
                    target="_blank"
                    href={event.rsvp_link}
                    className={styles.headline}
                  >
                    {event.title}
                  </a>
                  <div className={styles.date}>{event.date}</div>
                  <div className={styles.description}>{event.description}</div>
                </div>
              </div>
              {events.results.length - 1 !== index && (
                <hr className={styles.separator} aria-hidden={true} />
              )}
            </div>
          );
        })}
      </SectionContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    events: state.upcomingEvents,
  };
};

const mapDispatchToProps = {
  getEvents,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpcomingEvents);
